var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('div',{staticClass:"logo-content",on:{"click":_vm.logoClick}},[_c('img',{attrs:{"src":require("../../../static/images/logo.png"),"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }